<template>
  <nav class="app-pagination" :aria-label="ariaLabel">
    <button
      class="app-pagination-btn"
      type="button"
      :disabled="currentPage <= 1"
      :aria-label="previousLabel"
      @click="emitPage(currentPage - 1)"
    >
      <i class="fa-solid fa-chevron-left"></i>
      <span v-if="showLabels">{{ previousText }}</span>
    </button>
    <span class="app-pagination-status">
      {{ pageText }} {{ currentPage }} / {{ totalPages }}
    </span>
    <button
      class="app-pagination-btn"
      type="button"
      :disabled="currentPage >= totalPages"
      :aria-label="nextLabel"
      @click="emitPage(currentPage + 1)"
    >
      <span v-if="showLabels">{{ nextText }}</span>
      <i class="fa-solid fa-chevron-right"></i>
    </button>
  </nav>
</template>

<script>
import { scrollToPageTop } from '../utils/pageScroll'

export default {
  name: 'AppPagination',
  props: {
    page: {
      type: Number,
      required: true,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    ariaLabel: {
      type: String,
      default: 'Pagination',
    },
    pageText: {
      type: String,
      default: 'Page',
    },
    previousText: {
      type: String,
      default: 'Prev',
    },
    nextText: {
      type: String,
      default: 'Next',
    },
    showLabels: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['update:page', 'change'],
  computed: {
    currentPage() {
      return Math.min(Math.max(Number(this.page) || 1, 1), this.totalPages)
    },
    previousLabel() {
      return `${this.previousText} ${this.pageText.toLowerCase()}`
    },
    nextLabel() {
      return `${this.nextText} ${this.pageText.toLowerCase()}`
    },
  },
  methods: {
    emitPage(page) {
      const nextPage = Math.min(Math.max(page, 1), this.totalPages)
      if (nextPage === this.currentPage) return
      scrollToPageTop()
      this.$emit('update:page', nextPage)
      this.$emit('change', nextPage)
    },
  },
}
</script>
